import React from "react";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { formatNumber } from "../Utility/DataguardConstant";

const RadialProgress = ({ data, loc }) => {
  const renderClassNames = () => {
    if (loc === "detailsPage") {
      return "sys-guard-radial-progress-bar-container detailsPage";
    } else {
      return "sys-guard-radial-progress-bar-container";
    }
  };

  return (
    <div className={renderClassNames()}>
      {data.map((e, index) => (
        <div key={index} className="sys-guard-text-container">
          <img src={e.img} alt={e.alt} />
          <div className="sys-guard-radial-text">{e.title}</div>
          <div className="sys-guard-radial-progress">
            <CircularProgressbarWithChildren
              value={e.data.percentage}
              styles={buildStyles({
                pathColor: e.colors[0],
                strokeLinecap: "butt",
                trailColor: "#E6E9FA",
              })}
              strokeWidth={10}
            >
              <div className="circular-progress-bar-text">
                <div
                  className="text-sm"
                  title={`${e.data.value}/${e.data.maxValue}`}
                >
                  {`${formatNumber(e.data.value)}/${formatNumber(
                    e.data.maxValue
                  )}`}
                </div>
                <div className="text-l">{`${e.data.percentage}%`}</div>
              </div>
            </CircularProgressbarWithChildren>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RadialProgress;
